/* MPX QA fixes (Oct 2026): brand line from title, size labels, RTL review quotes, cart reassurance */
(function () {
  'use strict';
  var d = document, BR = null;
  function brands() {
    if (BR) return BR; BR = [];
    try { BR = (JSON.parse(d.getElementById('MpxSearchCfg').textContent).brands || []).map(function (b) { return b[0]; }).sort(function (a, b) { return b.length - a.length; }); } catch (e) {}
    return BR;
  }
  function fold(t) { return (t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); }
  var SZ = [[/^XXXLARGE$/, '3XL'], [/^XXLARGE$/, '2XL'], [/^XLARGE$/, 'XL'], [/^LARGE$/, 'L'], [/^MEDIUM$/, 'M'], [/^XSMALL$/, 'XS'], [/^SMALL$/, 'S'], [/^XXXL$/, '3XL'], [/^XXL$/, '2XL']];
  function size(v) { var u = v.trim().toUpperCase().replace(/[\s-]+/g, ''); for (var i = 0; i < SZ.length; i++) if (SZ[i][0].test(u)) return SZ[i][1]; return /^[0-9XSML+]+$/.test(u) ? u : v.trim(); }
  function fix(root) {
    root = root || d;
    root.querySelectorAll('.mpx-card__sizes-line:not([data-n])').forEach(function (el) {
      el.textContent = el.textContent.split('·').map(function (x) { return /^\s*\+/.test(x) ? x.trim() : size(x); }).join(' · ');
      el.setAttribute('data-n', '');
    });
    root.querySelectorAll('.mpx-card__info:not([data-b])').forEach(function (info) {
      info.setAttribute('data-b', '');
      if (info.querySelector('.mpx-card__brand')) return;
      var el = info.querySelector('.mpx-card__title'); if (!el) return;
      var raw = (el.textContent || '').trim(), f = fold(raw);
      var hit = brands().filter(function (b) { var fb = fold(b); return f.indexOf(fb) === 0 && /^(\s|$)/.test(f.slice(fb.length)); })[0];
      if (!hit) return;
      var sp = d.createElement('span'); sp.className = 'mpx-card__brand'; sp.textContent = hit; info.insertBefore(sp, el);
      var rest = raw.slice(hit.length).trim(); if (rest) el.textContent = rest;
    });
    /* cart drawer: reassurance line under the checkout button (COD / open before pay / free delivery) */
    root.querySelectorAll('.drawer__footer-buttons:not([data-mpx-cod])').forEach(function (f) {
      f.setAttribute('data-mpx-cod', '');
      var p = d.createElement('p'); p.className = 'mpx-cod-line';
      p.innerHTML = '<span>Cash on delivery</span><span>Open before you pay</span><span>Free delivery over LE 4,000</span>';
      f.parentNode.insertBefore(p, f.nextSibling);
    });
    root.querySelectorAll('.mpx-review__q[dir="rtl"]:not([data-q])').forEach(function (q) {
      q.textContent = q.textContent.trim().replace(/^[“”"]+|[“”"]+$/g, '').trim();
      q.setAttribute('data-q', '');
    });
  }
  function boot() {
    fix();
    var t = 0;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(fix, 60); }).observe(d.body, { childList: true, subtree: true });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
